import { cva } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-md border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      size: {
        small: 'px-1.5 py-0.5 text-xs',
        medium: 'px-2.5 py-0.5 text-xs',
        large: 'px-3 py-1 text-base',
      },
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        chip: 'bg-secondary text-foreground font-normal',
        outline: 'text-foreground border-border',
        'outline-primary': 'border-primary text-primary hover:bg-primary/10',
        'outline-secondary':
          'border-secondary text-secondary hover:bg-secondary/10',
        'outline-destructive':
          'border-destructive text-destructive hover:bg-destructive/10',
        'outline-success':
          'border-[--label-green-foreground] text-[--label-green-foreground] hover:bg-[--label-green-foreground]/10',
        'outline-warning':
          'border-amber-500 text-amber-500 hover:bg-amber-500/10',
        'outline-info': 'border-blue-500 text-blue-500 hover:bg-blue-500/10',
        success:
          'border-transparent bg-[--label-green-foreground] text-white shadow hover:bg-[--label-green-foreground]',
        warning:
          'border-transparent bg-amber-500 text-white shadow hover:bg-amber-600',
        info: 'border-transparent bg-blue-500 text-white shadow hover:bg-blue-600',
        ghost:
          'border-transparent bg-background text-foreground hover:bg-muted',
        muted:
          'border-transparent bg-muted text-muted-foreground hover:bg-muted/80',
      },
    },
    defaultVariants: {
      size: 'medium',
      variant: 'default',
    },
  },
)

function Badge({ className, variant, size, ...props }) {
  return (
    <span
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
